/**
 * Lavoratore - SPECIFICHE 2.1
 *
 * Anagrafica lavoratore con dati immutabili + dati variabili (ultimo noto).
 */
import { z } from 'zod';
import { SessoSchema, str, dateStr, periodoStr } from './common.ts';

export const LavoratoreSchema = z.object({
  id: z.number(),
  // Immutabili
  codiceFiscale: str,
  cognome: z.string(),
  nome: z.string(),
  sesso: SessoSchema,
  dataNascita: dateStr,
  comuneNascita: str,
  provinciaNascita: str,
  // Variabili (ultimo noto da qualsiasi cassa)
  via: str,
  cap: str,
  comune: str,
  provincia: str,
  telefono: str,
  cellulare: str,
  email: str,
  // Sistema
  ultimoPeriodo: periodoStr, // YYYYMM - periodo dati variabili
  createdAt: str,
  updatedAt: str,
});

export type Lavoratore = z.infer<typeof LavoratoreSchema>;

// Per INSERT (senza id e timestamp)
export type LavoratoreInsert = Omit<Lavoratore, 'id' | 'createdAt' | 'updatedAt'>;

// Dati variabili per UPDATE
export type LavoratoreVariabili = Pick<Lavoratore, 'via' | 'cap' | 'comune' | 'provincia' | 'telefono' | 'cellulare' | 'email'>;
